import { IS_DEVELOPMENT } from "@utils/env-management"

export function onBeforePageUnload() {
    if (IS_DEVELOPMENT) return
    const message = "Данные вашей анкеты будут утеряны. Вы хотите закрыть страницу?"
    window.event?.preventDefault()
    return message
}
